export default __webpack_public_path__ + "static/media/magazine1.dcbe0823.jpg";